/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TunnelMetricPoint = {
  activeRequests?: number | undefined;
  canceled?: number | undefined;
  /**
   * An observed producer reported aggregate loss since its last restart
   */
  collectionPartial: boolean;
  /**
   * Average of time-aligned sums of observed gateway connections. Missing owners are not zero.
   */
  connections?: number | undefined;
  connectionsOpened?: number | undefined;
  consumerSessions?: number | undefined;
  /**
   * Number of observed 15-second gateway sampling slots
   */
  coverageSamples: number;
  /**
   * Terminal errors completed in this bucket
   */
  errors?: number | undefined;
  incomplete?: number | undefined;
  /**
   * Other observed MCP request attempts
   */
  otherRequests?: number | undefined;
  /**
   * Histogram upper bound for median completion latency, -1 means above 60 seconds
   */
  p50Ms?: number | undefined;
  /**
   * Histogram upper bound for p95 completion latency, -1 means above 60 seconds
   */
  p95Ms?: number | undefined;
  /**
   * Requests Speakeasy rejected before they reached the MCP server, for example by policy. Not counted as errors.
   */
  rejected?: number | undefined;
  /**
   * Observed producer-minute heartbeats; proves only observed coverage, not every replica
   */
  requestCoverageSamples: number;
  /**
   * Terminal MCP successes completed in this bucket
   */
  successes?: number | undefined;
  time: Date;
  /**
   * Observed tools/call attempts
   */
  toolCalls?: number | undefined;
  /**
   * Observed tools/list attempts
   */
  toolsList?: number | undefined;
};

/** @internal */
export const TunnelMetricPoint$inboundSchema: z.ZodMiniType<
  TunnelMetricPoint,
  unknown
> = z.pipe(
  z.object({
    active_requests: z.optional(z.number()),
    canceled: z.optional(z.int()),
    collection_partial: z.boolean(),
    connections: z.optional(z.number()),
    connections_opened: z.optional(z.int()),
    consumer_sessions: z.optional(z.number()),
    coverage_samples: z.int(),
    errors: z.optional(z.int()),
    incomplete: z.optional(z.int()),
    other_requests: z.optional(z.int()),
    p50_ms: z.optional(z.int()),
    p95_ms: z.optional(z.int()),
    rejected: z.optional(z.int()),
    request_coverage_samples: z.int(),
    successes: z.optional(z.int()),
    time: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    tool_calls: z.optional(z.int()),
    tools_list: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "active_requests": "activeRequests",
      "collection_partial": "collectionPartial",
      "connections_opened": "connectionsOpened",
      "consumer_sessions": "consumerSessions",
      "coverage_samples": "coverageSamples",
      "other_requests": "otherRequests",
      "p50_ms": "p50Ms",
      "p95_ms": "p95Ms",
      "request_coverage_samples": "requestCoverageSamples",
      "tool_calls": "toolCalls",
      "tools_list": "toolsList",
    });
  }),
);

export function tunnelMetricPointFromJSON(
  jsonString: string,
): SafeParseResult<TunnelMetricPoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunnelMetricPoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunnelMetricPoint' from JSON`,
  );
}
